// removed by extract-text-webpack-plugin
module.exports = {"side-bar":"style__side-bar___2zzrE","item":"style__item___3qr9f","item--active":"style__item--active___puiUh","icon":"style__icon___WEih6","title":"style__title___1-wFq","link":"style__link___1uI_g","profile_image":"style__profile_image___2Bhvz"};


//////////////////
// WEBPACK FOOTER
// ./components/AdminSideBar/style.scss
// module id = 1272
// module chunks = 0